

export default function sockets(url){
  let connected = false
  let observers = []
  let maxwait = 30000
  let maxtries = 10
  let retry_timeout=1000
  let reconnecting
  let reconTimer
  let connection
  let message

  const on = (name,cback)=>{
    observers.push({name:name,cback:cback})
  }

  const emit = (name,data)=>{
    if(connected){
      connection.send(JSON.stringify({name:name,data:data}))
    }else{
      console.log("could not send",name) //perhaps push onto queue, then send when reconnected?
    }
  }

  function connect(){
    let socket
    if(!connected && maxtries > 0){
      maxtries--
      let protocol = window.location.protocol == "https:" ? "wss://" : "ws://"
      try{
        socket = new WebSocket(protocol+window.location.host+url+"?_csrf="+window.csrf+"&v=0.2")
      }catch(err){
        console.log("no sockets")
        return
      }
      socket.onopen = (event =>{
        connected = true
        connection = socket
        reconnecting = false
        observers.filter(ob => ob.name=="connected" && ob.cback()) // call back on connected
      })
      socket.onmessage = (res =>{
        message = JSON.parse(res.data)
        observers.forEach(ob => message.name == ob.name && ob.cback(message.data) )
      })
      socket.onerror = (event => console.log("socket error",event) )
      socket.onclose = (e => {
        console.log("onclose",e.code,e) 
        connected = false
        if(!reconnecting && e.code == 1006){ // 1006 abnormal closure, ie server going down
          reconnecting = true
          reconTimer = setTimeout =>
            connect()
            retry_timeout *= 1.5
            if (retry_timeout > maxwait) retry_timeout = maxwait 
          ,retry_timeout
        }
      })
      window.addEventListener("beforeunload",()=>{ 
        clearTimeout(reconTimer)
        socket.close()
      })
    }
  }
  connect()
  return {on,emit}
}